export const copyToClipboard = (id:string) => {
	const element = document.getElementById(id) as HTMLInputElement;
	try{
		element.select();
		document.execCommand("copy");
	}catch(e){
		throw `Error copying element '${id}' to clipboard`;
	}
};